<style scoped>
    .hide {
        display: none;
    }

    .font-ruangan {
        font-size: 0.8rem;
    }
</style>

<template>
    <div class="mt-3">
        <div class="card">
            <div class="card-header">
                Update Ruangan
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <!-- <button class="btn btn-sm btn-primary" @click="createKelas">Tambah Kelas</button> -->
                        <button class="btn btn-sm btn-primary" @click="getDataAplicares">Get Data Aplicares</button>
                        <button class="btn btn-sm btn-primary" @click="resetData">Reset Data</button>
                    </div>
                </div>

                <div v-if="create || edit">
                    <hr>
                    <div class="card-title">Data Kelas</div>

                    <div class="row mt-3">
                        <div class="col-sm-6">
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Kode Kelas</div>
                                <div class="col">
                                    <input type="text" class="form-control" v-model="data_kelas.kode_kelas">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Nama Kelas</div>
                                <div class="col">
                                    <input type="text" class="form-control" v-model="data_kelas.nama_kelas">
                                </div>
                            </div>
                            <div v-if="edit" class="row mt-3">
                                <div class="col-sm-4 text-right col-form-label">Status</div>
                                <div class="col">
                                    <select v-model="data_kelas.status" class="form-control">
                                        <option value="1">Aktif</option>
                                        <option value="2">Tidak Aktif</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-sm btn-primary" @click="simpanKelas">Simpan</button>
                        <button class="btn btn-sm btn-danger" @click="cancelCreate">Batal</button>
                    </div>
                </div>

                <div>
                    <hr>
                    <h5 class="card-title">Daftar Kelas</h5>

                    <div class="mt-3">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">No</th>
                                    <th scope="col">Kode Kelas</th>
                                    <th scope="col">Nama Kelas</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Aksi</th>
                                </tr>
                            </thead>
                            <tbody v-for="(kls, idx) in list_kelas" :key="idx">
                                <tr>
                                    <td rowspan="2">{{ idx + 1 }}</td>
                                    <td>{{ kls.kode_kelas }}</td>
                                    <td>{{ kls.nama_kelas }}</td>
                                    <td>{{ kls.status == 1 ? 'Aktif' : 'Tidak Aktif' }}</td>
                                    <td>
                                        <button class="btn btn-outline-primary btn-sm" @click="updateRuangan(list_kelas, kls)">Update Ruangan</button>
                                        <!-- <button class="btn btn-outline-primary btn-sm" @click="editKelas(kls)">Edit</button> -->
                                        <!-- <button class="btn btn-outline-danger btn-sm" @click="deleteKelas(kls)">Delete</button> -->
                                    </td>
                                </tr>
                                <tr class="hide" :id="'ruangan-' + kls.id">
                                    <td colspan="4">
                                        <div class="row">
                                            <div class="col">
                                                <button class="btn btn-sm btn-primary" @click="createRuangan(kls.id)">Tambah Ruangan</button>
                                            </div>
                                        </div>

                                        <div v-if="create_ruangan || edit_ruangan">
                                            <hr>
                                            <div class="card-title">Data Ruangan</div>

                                            <div class="row mt-3">
                                                <div class="col-sm-6">
                                                    <div class="row mt-3">
                                                        <div class="col-sm-6 text-right col-form-label">Kode Ruangan</div>
                                                        <div class="col">
                                                            <input type="text" class="form-control" v-model="data_ruangan.kode_ruangan">
                                                        </div>
                                                    </div>
                                                    <div class="row mt-3">
                                                        <div class="col-sm-6 text-right col-form-label">Nama Ruangan</div>
                                                        <div class="col">
                                                            <input type="text" class="form-control" v-model="data_ruangan.nama_ruangan">
                                                        </div>
                                                    </div>
                                                    <div v-if="edit_ruangan">
                                                        <div class="row mt-3">
                                                            <div class="col-sm-6 text-right col-form-label">Kapasitas</div>
                                                            <div class="col">
                                                                <input type="number" class="form-control" v-model="data_ruangan.kapasitas">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-6 text-right col-form-label">Tersedia</div>
                                                            <div class="col">
                                                                <input type="number" class="form-control" v-model="data_ruangan.tersedia">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-6 text-right col-form-label">Tersedia Pria</div>
                                                            <div class="col">
                                                                <input type="number" class="form-control" v-model="data_ruangan.tersedia_l">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-6 text-right col-form-label">Tersedia Wanita</div>
                                                            <div class="col">
                                                                <input type="number" class="form-control" v-model="data_ruangan.tersedia_p">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-6 text-right col-form-label">Tersedia Pria/Wanita</div>
                                                            <div class="col">
                                                                <input type="number" class="form-control" v-model="data_ruangan.tersedia_lp">
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-sm-6 text-right col-form-label">Status</div>
                                                            <div class="col">
                                                                <select v-model="data_ruangan.status" class="form-control">
                                                                    <option value="1">Aktif</option>
                                                                    <option value="2">Tidak Aktif</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3">
                                                <button class="btn btn-sm btn-primary" @click="simpanRuangan">Simpan</button>
                                                <button class="btn btn-sm btn-danger" @click="cancelCreateRuangan">Batal</button>
                                            </div>
                                        </div>

                                        <hr>
                                        <p class="card-title">Daftar Ruangan</p>

                                        <table class="table table-striped font-ruangan">
                                            <thead>
                                                <tr>
                                                    <th>Kode<br>Ruangan</th>
                                                    <th>Nama<br>Ruangan</th>
                                                    <th>Kapasitas</th>
                                                    <th>Tersedia</th>
                                                    <th>Tersedia<br>Pria</th>
                                                    <th>Tersedia<br>Wanita</th>
                                                    <th>Tersedia<br>Pria/Wanita</th>
                                                    <th>Status</th>
                                                    <th>Aksi</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="ruang, idx_ruang in kls.ruangan" :key="idx_ruang">
                                                    <td>{{ ruang.kode_ruangan }}</td>
                                                    <td>{{ ruang.nama_ruangan }}</td>
                                                    <td>{{ ruang.kapasitas }}</td>
                                                    <td>{{ ruang.tersedia }}</td>
                                                    <td>{{ ruang.tersedia_l }}</td>
                                                    <td>{{ ruang.tersedia_p }}</td>
                                                    <td>{{ ruang.tersedia_lp }}</td>
                                                    <td>{{ ruang.status == 1 ? 'Aktif' : 'Tidak Aktif' }}</td>
                                                    <td>
                                                        <button class="btn btn-outline-success btn-sm" @click="pushRuangan(ruang)">Push to Aplicares</button>
                                                        <button class="btn btn-outline-primary btn-sm" @click="editRuangan(ruang)"><i class="fa fa-edit"></i></button>
                                                        <button class="btn btn-outline-danger btn-sm" @click="deleteRuangan(ruang)"><i class="fa fa-trash"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            create: false,
            edit: false,
            create_ruangan: false,
            edit_ruangan: false,
            data_kelas: {
                id: '',
                nama: '',
                status: '',
            },
            data_ruangan: {
                id_kelas: '',
                id: '',
                kode_ruangan: '',
                nama_ruangan: '',
                kapasitas: '',
                tersedia: '',
                tersedia_l: '',
                tersedia_p: '',
                tersedia_lp: '',
                status: '',
            },
            list_kelas: []
        }
    },
    created() {
        this.getKelas()
    },
    methods: {
        createKelas() {
            this.data_kelas = {
                id: '',
                kode_kelas: '',
                nama_kelas: '',
                status: '',
            }

            this.create = true
            this.edit = false
        },
        simpanKelas() {
            this.$isLoading(true)
            let uri = '/api/save-aplicares-kelas'

            this.axios.post(uri, this.data_kelas).then(response => {
                if (response.data.status == 'success') {
                    this.getKelas()
                    this.create = false
                    this.edit = false
                    this.data_kelas = {
                        id: '',
                        nama: '',
                        status: '',
                    }
                    this.$isLoading(false)
                } else {
                    alert(response.data.message)
                    this.$isLoading(false)
                }
            })
        },
        cancelCreate() {
            this.data_kelas = {
                id: '',
                nama: '',
                status: '',
            }
            this.create = false
            this.edit = false
        },
        editKelas(kelas) {
            this.data_kelas = {
                id: kelas.id,
                kode_kelas: kelas.kode_kelas,
                nama_kelas: kelas.nama_kelas,
                status: kelas.status,
            }

            this.create = false
            this.edit = true
        },
        deleteKelas(kelas) {
            if (confirm('Kelas akan dihapus. Yakin?')) {
                alert('data dihapus')
            } else {
                alert('data batal dihapus')
            }
        },
        getKelas() {
            this.$isLoading(true)
            let uri = '/api/get-aplicares-kelas'

            this.axios.get(uri).then(response => {
                this.list_kelas = response.data.kelas

                this.$isLoading(false)
            })
        },
        updateRuangan(list_kelas, kelas) {
            this.cancelCreateRuangan()

            list_kelas.forEach(kls => {
                if (kls.id != kelas.id) {
                    $('#ruangan-' + kls.id).addClass('hide')
                }
            });

            $('#ruangan-' + kelas.id).toggleClass('hide')

            this.getKelas()
        },
        createRuangan(id_kelas) {
            this.data_ruangan = {
                id_kelas: id_kelas,
                id: '',
                kode_ruangan: '',
                nama_ruangan: '',
                kapasitas: '',
                tersedia: '',
                tersedia_l: '',
                tersedia_p: '',
                tersedia_lp: '',
                status: '',
            }

            this.create_ruangan = true
            this.edit_ruangan = false
        },
        simpanRuangan() {
            this.$isLoading(true)
            let uri = '/api/save-aplicares-ruangan'

            this.axios.post(uri, this.data_ruangan).then(response => {
                if (response.data.status == 'success') {
                    this.getKelas()
                    this.create_ruangan =  false
                    this.edit_ruangan =  false
                    this.$isLoading(false)
                } else {
                    alert(response.data.message)
                    this.$isLoading(false)
                }
            })
        },
        cancelCreateRuangan() {
            this.data_ruangan = {
                id_kelas: '',
                id: '',
                kode_ruangan: '',
                nama_ruangan: '',
                kapasitas: '',
                tersedia: '',
                tersedia_l: '',
                tersedia_p: '',
                status: '',
            }
            this.create_ruangan = false
            this.edit_ruangan = false
        },
        editRuangan(ruang) {
            this.data_ruangan.id_kelas = ruang.id_kelas
            this.data_ruangan.id = ruang.id
            this.data_ruangan.kode_ruangan = ruang.kode_ruangan
            this.data_ruangan.nama_ruangan = ruang.nama_ruangan
            this.data_ruangan.kapasitas = ruang.kapasitas
            this.data_ruangan.tersedia = ruang.tersedia
            this.data_ruangan.tersedia_l = ruang.tersedia_l
            this.data_ruangan.tersedia_p = ruang.tersedia_p
            this.data_ruangan.tersedia_lp = ruang.tersedia_lp
            this.data_ruangan.status = ruang.status

            this.create_ruangan = false
            this.edit_ruangan = true
        },
        deleteRuangan(ruang) {
            if (confirm('Ruangan akan dihapus. Yakin?')) {
                this.$isLoading(true)
                let id_ruangan = ruang.id
                let uri = '/api/delete-aplicares-ruangan'

                this.axios.post(uri, {
                    id_ruangan: id_ruangan
                }).then(response => {
                    this.$isLoading(false)
                    if (response.data.status == 'success') {
                        alert('Ruangan Berhasil Dihapus')
                        this.getKelas()
                    } else {
                        alert(response.data.message)
                    }
                })
            } else {
                alert('data batal dihapus')
            }
        },
        pushRuangan(ruang) {
            this.$isLoading(true)
            let uri = '/api/push-aplicares-ruangan'

            this.axios.post(uri, ruang).then(response => {
                if (response.data.status == 'success') {
                    if ('metadata' in response.data.push_result) {
                        if ('message' in response.data.push_result.metadata) {
                            alert(response.data.push_result.metadata.message)
                        }
                    }
                    this.getKelas()
                    this.$isLoading(false)
                } else {
                    alert(response.data.message)
                    this.$isLoading(false)
                }
            })
        },
        getDataAplicares() {
            this.$isLoading(true)
            let uri = '/api/get-data-aplicares'

            this.axios.get(uri).then(response => {
                this.getKelas()
                this.$isLoading(false)
            })
        },
        resetData() {
            this.$isLoading(true)
            let uri = '/api/reset-data-bed'

            this.axios.get(uri).then(response => {
                this.$isLoading(false)
                if (response.data.status == 'success') {
                    console.log(response)
                }
                this.getKelas()
                // this.$isLoading(false)
            }).catch(error => {
                this.$isLoading(false)
            })
        }
    }
}
</script>